// extracted by mini-css-extract-plugin
module.exports = {"container":"bg-parallax_container__i9rwD"};